import { v4 as uuid } from 'uuid';
import { extractExcerpt, replaceTags, sanitizeHtml, toUUID } from '../../util/transform';
import type { IChecklistItem } from './ChecklistItem.interface';
import { epoch, formatDate, formatEpochAsDate, future, tz, utc } from '../../util/datetime';

export default class ChecklistItem implements IChecklistItem {
  id: string;
  idOwner: string;
  name: string;
  description: string;
  due: number;
  isDue: boolean;
  isOverdue: boolean;
  isPartial: boolean;
  isCompleted: boolean;
  timeStamp: number;
  isActive: boolean;

  getName() {
    return this.name;
  }

  getExcerpt() {
    return extractExcerpt(replaceTags(this.getDescription(), ' '));
  }

  getDescription() {
    return this.description;
  }

  getItems() {
    return this.items[0].name;
  }

  getDueDateSort() {
    return (parseInt(this.timeStamp, 10) + parseInt(this.due, 10) * 86400).toString();
  }

  getTimeStampSort() {
    return this.timeStamp;
  }

  getDate(timeZone, locale, localeFormat) {
    return formatEpochAsDate(this.timeStamp, timeZone, locale, localeFormat);
  }

  getDueDate(timeZone, locale, localeFormat) {
    return formatDate(
      tz(future(utc(this.timeStamp), 'days', this.due), timeZone),
      locale,
      localeFormat
    );
  }

  static build = (data: IChecklistItem) => new ChecklistItem(data);
  static blank = () => new ChecklistItem({ id: uuid(), isActive: true });

  /**
   * Constructor
   * @param {IChecklistItem} data
   */
  constructor(data?: IChecklistItem) {
    this.id = toUUID(data?.id) || uuid();
    this.idOwner = toUUID(data?.idOwner);
    this.name = data?.name || '';
    this.description = sanitizeHtml(data?.description || '');
    this.due = parseInt(data?.due || 3, 10);
    this.isDue = data?.isDue === true;
    this.isOverdue = data?.isOverdue === true;
    this.isPartial = data?.isPartial === true;
    this.isCompleted = data?.isCompleted === true;
    this.timeStamp = epoch(utc(data?.timeStamp));
    this.isActive = data?.isActive === true;
  }
}
